import { ChatRoomList } from 'ui/components/company/patterns/ChatRoom/ChatRoomList';

/**
 * 企業系チャットページ
 */
export const CompanyChatRoom: React.FC = () => {
    return <ChatRoomList />;
};
